import { ApiRequest, deleteItem, postItem, putItem } from "utils/ApiUtils";
import buildQuery from 'odata-query';
import ODataUtil from './ODataUtil';
import { CustomField } from 'classes';
const projects_endpoint = "/Project";

function convert_customFields_to_table_schema({ "value": items, "@odata.count": count }, status) {
  const data = items[0]
  const rows = data.ProjectCustomField.map(r => {
    const customFieldUtils = new CustomField(r)
    customFieldUtils.CustomFieldId = r.CustomFieldId
    customFieldUtils.CustomFieldNameId = r.CustomFieldName.CustomFieldNameId;
    customFieldUtils.FieldValue = r.FieldValue
    customFieldUtils.Description_CustomFieldName = r.CustomFieldName ? r.CustomFieldName.Description : ""
    return customFieldUtils
  })

  count = rows.length
  return {
    data: rows, count
  }
}

async function getProjectInfo(page, per_page, orderByInfo, orderByDirection, search, filters) {
  const { skip, count, top, expand, orderBy, mappedFilter } = ODataUtil.UtilityBuilderNestedv3(
    per_page, page, CustomField.expand, orderByInfo, orderByDirection, filters
  );
  const filter = {};
  const isDefaults = filters.find(r => r.defaults);
  
  if (isDefaults) {
    const defaults = isDefaults.defaults;
    if(defaults.projectId) filter["ProjectId"] = { eq: { type: 'guid', value: defaults.projectId }};
  };
  const allFilters = mappedFilter.reduce((a, b) => ({...a, ...b}), filter);
  const params = buildQuery({ count, top, skip, orderBy, expand, filter: allFilters });
  const data = await ApiRequest(projects_endpoint, params)
  return convert_customFields_to_table_schema(data)
}

async function deleteCustomField(iDunno, customField) {
  const endpoint = `${projects_endpoint}/DeleteCustomFields`;
  const params = `?id=${customField.CustomFieldId}`;
  const result = await deleteItem(endpoint, params);
  return result;
}


async function updateCustomField(data, projectID) {
  data.ProjectId = projectID;
  const params = `?projectId=${projectID}`;
  const resourcePath = `${projects_endpoint}/Fields`;
  const result = await putItem(resourcePath, params, data, true);
  return result;
}

export { getProjectInfo, updateCustomField, deleteCustomField }